import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const SidebarItem = ({
    option,
    sidebarFor,
    isUserPrimary,
    currentDashboardRoute,
    setCurrentDashboardRoute,
    role,
}) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpanded = () => setIsExpanded((prev) => !prev);

    return (
        <>
            <li className='links-set' key={option.name} style={{ userSelect: 'none' }}>
                <div
                    className='d-flex align-items-center justify-content-start link-line'
                    style={{ cursor: 'pointer', position: 'relative', userSelect: 'none' }}
                    title={option.name}
                    onClick={toggleExpanded}
                >
                    <option.icon color='#738DA6' height={16} width={16} />
                </div>
            </li>

            {isExpanded && (
                <>
                    {option.subOptions.map((subOption, subIndex) => {
                        if (
                            sidebarFor !== 'admin' &&
                            subOption.name === 'Safety Meetings' &&
                            !isUserPrimary
                        ) {
                            return null;
                        }

                        if (sidebarFor === 'admin' && !subOption?.allowedRoles.includes(role)) {
                            return null;
                        }

                        return (
                            <li key={subIndex} className='links-set' title={subOption.name}>
                                <Link
                                    onClick={() => {
                                        setCurrentDashboardRoute(subOption.route[0]);
                                    }}
                                    to={subOption.route[0]}
                                    className={`d-flex align-items-center justify-content-start link-line ${
                                        subOption.route.includes(currentDashboardRoute) && 'active'
                                    }`}
                                    style={{
                                        textDecoration: 'none',
                                        color: 'var(--col-body)',
                                    }}
                                >
                                    <subOption.icon color='#738DA6' height={16} width={16} />
                                </Link>
                            </li>
                        );
                    })}
                </>
            )}
        </>
    );
};

export default SidebarItem;
